import PropTypes from "prop-types";
export const InfoStatusTypes = Object.freeze({
    submitted: "submitted",
    cancelled: "cancelled",
    loading: "loading",
});
export const InfoStatusPositions = Object.freeze({
    left: "left",
    center: "center",
    right: "right",
});
export const InfoStatusTypesPropTypes = PropTypes.oneOf(Object.values(InfoStatusTypes));
export const InfoStatusPositionsPropTypes = PropTypes.oneOf(Object.values(InfoStatusPositions));
//# sourceMappingURL=InfoStatusPropTypes.js.map